import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { SiteProvider } from "@/context/SiteContext";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import ProtectedRoute from "@/components/ProtectedRoute";

import Home from "@/pages/Home";
import Cars from "@/pages/Cars";
import VehicleDetail from "@/pages/VehicleDetail";
import Landing from "@/pages/Landing";
import Legal from "@/pages/Legal";
import Faq from "@/pages/Faq";
import Contact from "@/pages/Contact";
import Guides from "@/pages/Guides";
import GuideDetail from "@/pages/GuideDetail";
import NotFound from "@/pages/NotFound";
import Login from "@/pages/admin/Login";
import Dashboard from "@/pages/admin/Dashboard";
import VehicleForm from "@/pages/admin/VehicleForm";
import Settings from "@/pages/admin/Settings";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <SiteProvider>
          <AuthProvider>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/cars" element={<Cars />} />
              <Route path="/cars/:slug" element={<VehicleDetail />} />
              <Route path="/private-hire-car-rental-manchester" element={<Landing />} />
              <Route path="/manchester-phv-rental" element={<Navigate to="/private-hire-car-rental-manchester" replace />} />
              <Route path="/hybrid-phv-rental-manchester" element={<Navigate to="/hybrid-taxi-rental-manchester" replace />} />
              <Route path="/phv-rental-with-insurance" element={<Navigate to="/taxi-rental-with-insurance-manchester" replace />} />
              <Route path="/phv-rental-without-insurance" element={<Navigate to="/taxi-rental-without-insurance-manchester" replace />} />
              <Route path="/taxi-rental-manchester" element={<Landing />} />
              <Route path="/hybrid-taxi-rental-manchester" element={<Landing />} />
              <Route path="/uber-car-rental-manchester" element={<Landing />} />
              <Route path="/bolt-car-rental-manchester" element={<Landing />} />
              <Route path="/taxi-rental-with-insurance-manchester" element={<Landing />} />
              <Route path="/taxi-rental-without-insurance-manchester" element={<Landing />} />
              <Route path="/guides" element={<Guides />} />
              <Route path="/guides/:slug" element={<GuideDetail />} />
              <Route path="/faq" element={<Faq />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/privacy-policy" element={<Legal />} />
              <Route path="/cookie-policy" element={<Legal />} />
              <Route path="/terms" element={<Legal />} />
              <Route path="/rental-terms" element={<Legal />} />

              <Route path="/login" element={<Login />} />
              <Route path="/admin" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
              <Route path="/admin/vehicles/new" element={<ProtectedRoute><VehicleForm /></ProtectedRoute>} />
              <Route path="/admin/vehicles/:id" element={<ProtectedRoute><VehicleForm /></ProtectedRoute>} />
              <Route path="/admin/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />

              <Route path="*" element={<NotFound />} />
            </Routes>
            <Toaster position="top-center" richColors />
          </AuthProvider>
        </SiteProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
